const viewBoxSizes = {
    company: {
        small: "279 38 94 94",
        medium: "0 0 600 171",
        large: "0 0 600 171", // leaving the large size to not have a breaking change
    },
    enterprise: {
        small: "279 38 94 94",
        medium: "0 0 600 171",
        large: "0 0 608 171",
    },
};
export { viewBoxSizes };
//# sourceMappingURL=Logo.helpers.js.map